import { render, staticRenderFns } from "./coinapp-link.vue?vue&type=template&id=649d4c2a&"
import script from "./coinapp-link.vue?vue&type=script&lang=js&"
export * from "./coinapp-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports